<div
    class="entry"
    [class.emaillink--outlined]="outlined()"
>
    @if (title()) {
        <h3 class="entry__title">
            {{ title() }}
        </h3>
    }

    @if (email()) {
        <a
            class="entry__link"
            target="_blank"
            [attr.aria-label]="ariaLabel() ?? linkLabel() ?? email()"
            [href]="'mailto:' + email()"
        >
            <span>
                {{ linkLabel() ?? email() }}
            </span>
        </a>
    }
</div>
